import React, { useContext } from 'react';
import { CourseOptionDisplayModuleContext } from '../../../context';
import { CourseOptionFilterType } from '../../../constants';
import { OptionDisplay } from '../OptionDisplay';
import { OptionDisplayFilter } from '../OptionDisplayFilter';
import { OptionDisplayCard } from '../OptionDisplayCard';

export function OptionDisplayLayout() {
  const { rows, filters } = useContext(CourseOptionDisplayModuleContext);

  const deliveryTypeFilter = filters[CourseOptionFilterType.DELIVERY_TYPE];
  const languageFilter = filters[CourseOptionFilterType.LANGUAGE];
  const currencyFilter = filters[CourseOptionFilterType.CURRENCY];

  const filtersShown =
    deliveryTypeFilter.shown || languageFilter.shown || currencyFilter.shown;

  return (
    <OptionDisplay
      options={rows}
      filter={filtersShown && <OptionDisplayFilter />}
      renderOptionCard={(option) => <OptionDisplayCard option={option} />}
    />
  );
}
